import { render, staticRenderFns } from "./UserActionButton.vue?vue&type=template&id=a9f3e1ba&"
import script from "./UserActionButton.vue?vue&type=script&lang=js&"
export * from "./UserActionButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a9f3e1ba')) {
      api.createRecord('a9f3e1ba', component.options)
    } else {
      api.reload('a9f3e1ba', component.options)
    }
    module.hot.accept("./UserActionButton.vue?vue&type=template&id=a9f3e1ba&", function () {
      api.rerender('a9f3e1ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UserActionButton.vue"
export default component.exports